import React, { FC } from 'react';
import { Field, Toggle } from '@kontentino/ui';

type Props = {
  value: boolean;
  onChange: () => void;
};

const ProfileLogoAtTheEndToggle: FC<Props> = (props) => {
  return (
    <div className="tw-flex tw-items-center">
      <Field.Group className="tw-flex-1">
        <Field.Label required>Use logo at the end</Field.Label>
        <Field.Caption>
          Toggle this feature on if you wish to add a logo at the end of your
          carousel. The logo will be displayed as the last part of your post.
        </Field.Caption>
      </Field.Group>
      <div className="tw-ml-20">
        <Toggle onChange={props.onChange} checked={props.value} />
      </div>
    </div>
  );
};

export default ProfileLogoAtTheEndToggle;
